// extracted by mini-css-extract-plugin
export default {"xpButton":"XPButton_xpButton__59apU","xpLabel":"XPButton_xpLabel__ZG-99","primary":"XPButton_primary__6y8Ao"};